import { createSelector } from 'reselect';

import type { RootState } from '../../../../../configuration/setup/store';
import { ProductState } from '../../../checkout/resourceSelection/redux/types';
import { getServiceListResources } from '../redux/serviceOverview.redux';
import type { ResourcesBySku } from '../redux/types';

const getSku = (_state: RootState, sku: string) => sku;

export const makeGetServiceResourcesForSku = () =>
    createSelector([getSku, getServiceListResources], (sku: string, serviceResources: ResourcesBySku) =>
        serviceResources[sku]?.filter(
            resource =>
                resource.productState !== ProductState.INACTIVE &&
                resource.productState !== ProductState.PENDING_CANCELLATION
        )
    );

export const makeHasPendingActivationResources = () =>
    createSelector([getSku, getServiceListResources], (sku: string, serviceResources: ResourcesBySku) => {
        const resourcesInPendingActivation = serviceResources[sku]?.filter(
            asset => asset.productState === ProductState.PENDING_ACTIVATION
        );
        return !!resourcesInPendingActivation && resourcesInPendingActivation.length > 0;
    });
